import axios from 'axios';
import RouteUrls from '../common/RouteUrls';
import {getAuthToken} from '../common/authTokenUtil';

export const forcedChangePassword = async (orgName, loginName, password) => {
  try {
    const response = await axios({
      method: 'POST',
      url: RouteUrls.FORCED_CHANGE_PASSWORD,
      headers: {
        'Authorization': `Bearer ${getAuthToken()}`,
        'correlation-id':
          '12345',
        'client-id':
          'PNET',
        'device-id': '12345'
      },
      data: {
        organizationNumber: orgName,
        loginName: loginName,
        newPassword: password,
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}
